import { listDetailsActionTypes } from './Constants';
import shortid from 'shortid';

const initialState = {
	loading: false,
	words_with_performance: [],
	orderOptions: [],
	exerciseTypes: [],
	live_battle_exercise_types: [],
	prioritizedLanguage: '',
	listResults: {
		results: [],
		exerciseTypes: [],
	},
	paused_exercise: null,
	isOpenAddListModal: false,
	addListModalLoading: false,
	confirmationModal: {
		open: false,
		loading: false,
	},
	status: 'public',
	copyListModal: {
		open: false,
		loading: false,
		sharedGroups: [],
		listId: null,
	},
	songsLoading: false,
	songs: [],
};

export default function listDetailsReducer(state = initialState, action) {
	const { type, payload } = action;
	const {
		data,
		listResults,
		addListModalStatus,
		addListModalType,
		listData,
		status,
		songs,
		songsData,
	} = payload || {};

	switch (type) {
		case listDetailsActionTypes.GET_LIST_DETAILS_REQUEST:
		case listDetailsActionTypes.GET_LIST_RESULTS_REQUEST:
			return {
				...state,
				loading: true,
				shouldUpgrade: false,
				isShared: true,
			};
		case listDetailsActionTypes.CLEAR_LIST_DETAILS:
			return {
				...initialState,
			};

		case listDetailsActionTypes.GET_LIST_DETAILS_SUCCESS:
			return {
				...state,
				error: '',
				loading: false,
				...data,
				words_with_performance: data.words_with_performance.map((item) => ({
					...item,
					id: shortid.generate(),
					isChecked: false,
				})),
				defaultOrder: data.times_practiced > 0 ? 'Alle resultaten' : 'Origineel',
				exerciseTypes: data.exercise_types,
				prioritizedLanguage: data.prioritized_language.locale,
			};

		case listDetailsActionTypes.GET_LIST_RESULTS_SUCCESS:
			return {
				...state,
				loading: false,
				listResults: {
					...listResults,
					exerciseTypes: [
						{
							code: 'all',
							name: 'Alle oefenvormen',
							icon_name: null,
						},
						...listResults.exercise_types,
					],
				},
			};

		case listDetailsActionTypes.GET_LIST_DETAILS_ERROR:
		case listDetailsActionTypes.GET_LIST_RESULTS_ERROR:
			return {
				...state,
				loading: false,
			};

		case listDetailsActionTypes.TOGGLE_ADD_LIST_MODAL:
			return {
				...state,
				isOpenAddListModal: addListModalStatus,
				addListModalType,
			};

		case listDetailsActionTypes.ADD_LIST_REQUEST:
			return {
				...state,
				addListModalLoading: true,
			};

		case listDetailsActionTypes.ADD_LIST_ERROR:
			return {
				...state,
				addListModalLoading: false,
			};

		case listDetailsActionTypes.ADD_LIST_SUCCESS:
			return {
				...state,
				isOpenAddListModal: false,
				addListModalLoading: false,
			};

		case listDetailsActionTypes.UPDATE_LIST_SUCCESS:
			return {
				...state,
				...listData,
			};

		case listDetailsActionTypes.TOGGLE_CONFIRMATION_MODAL:
			return {
				...state,
				confirmationModal: {
					open: status,
					loading: false,
				},
			};

		case listDetailsActionTypes.DELETE_LIST_REQUEST:
			return {
				...state,
				confirmationModal: {
					open: true,
					loading: true,
				},
			};

		case listDetailsActionTypes.DELETE_LIST_SUCCESS:
			return {
				...state,
				confirmationModal: {
					open: false,
					loading: false,
				},
			};

		case listDetailsActionTypes.SET_LIST_STATUS:
			return {
				...state,
				status,
			};

		case listDetailsActionTypes.TOGGLE_COPY_LIST_MODAL:
			return {
				...state,
				copyListModal: {
					...state.copyListModal,
					...data,
				},
			};

		case listDetailsActionTypes.GET_LIST_SONGS_REQUEST:
			return {
				...state,
				songsLoading: true,
			};

		case listDetailsActionTypes.GET_LIST_SONGS_SUCCESS:
			return {
				...state,
				songsLoading: false,
				songs,
			};

		case listDetailsActionTypes.GET_LIST_SONGS_ERROR:
			return {
				...state,
				songsLoading: false,
			};

		case listDetailsActionTypes.DELETE_SONG_SUCCESS:
			return {
				...state,
				...songsData,
			};

		default:
			return state;
	}
}
